import { render, staticRenderFns } from "./BaseImageUpload.vue?vue&type=template&id=210c4488"
import script from "./BaseImageUpload.vue?vue&type=script&lang=js"
export * from "./BaseImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports